"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ButtonTitle;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _Text = _interopRequireDefault(require("./Text"));
var _excluded = ["disabled", "style", "disabledStyle"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ButtonTitle(props) {
  var disabled = props.disabled,
    style = props.style,
    disabledStyle = props.disabledStyle,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var titleStyles = [styles["default"], style, disabled && styles.disabled, disabled && disabledStyle];
  return /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({
    style: titleStyles
  }, rest));
}
ButtonTitle.propTypes = {
  disabled: _propTypes["default"].bool,
  style: _propTypes["default"].any,
  disabledStyle: _propTypes["default"].any
};
var styles = _reactNative.StyleSheet.create({
  "default": _objectSpread(_objectSpread({}, _styles.sizes.selectStyleByDefaultSize({
    small: {
      fontSize: 13
    },
    medium: {
      fontSize: 14
    },
    large: {
      fontSize: 18
    }
  })), {}, {
    lineHeight: 24,
    color: _styles.colors.clear
  }),
  disabled: {}
});